import type { SVGProps } from 'react';

const SvgDiagramArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="40"
    viewBox="0 0 6 40"
    fill="none"
    {...props}
  >
    <path
      d="M2.88672 40L5.77347 35L-3.41932e-05 35L2.88672 40ZM2.88672 0L2.38672 -2.18557e-08L2.38672 1L2.88672 1L3.38672 1L3.38672 2.18557e-08L2.88672 0ZM2.88672 3L2.38672 3L2.38672 5L2.88672 5L3.38672 5L3.38672 3L2.88672 3ZM2.88672 7L2.38672 7L2.38672 9L2.88672 9L3.38672 9L3.38672 7L2.88672 7ZM2.88672 11L2.38672 11L2.38672 13L2.88672 13L3.38672 13L3.38672 11L2.88672 11ZM2.88672 15L2.38672 15L2.38672 17L2.88672 17L3.38672 17L3.38672 15L2.88672 15ZM2.88672 19L2.38672 19L2.38672 21L2.88672 21L3.38672 21L3.38672 19L2.88672 19ZM2.88672 23L2.38672 23L2.38672 25L2.88672 25L3.38672 25L3.38672 23L2.88672 23ZM2.88672 27L2.38672 27L2.38672 29L2.88672 29L3.38672 29L3.38672 27L2.88672 27ZM2.88672 31L2.38672 31L2.38672 33L2.88672 33L3.38672 33L3.38672 31L2.88672 31ZM2.88672 35L2.38672 35L2.38672 37L2.88672 37L3.38672 37L3.38672 35L2.88672 35Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgDiagramArrowDown;
